<template>
  <div class="m-k__row m-k__row_producer">
    <div @click="toggle" class="m-k__c m-k__c_first" data-toogle-markup=".m-k__producer">
      {{ producer.name }}
      <div class="m-k__modifiers-list">
        <span v-for="modifier in producer.viewModifiers"
              :class="['m-k__modifier-dot', `m-k__modifier-dot_${modifier}`]"
        >
        </span>
      </div>
    </div>

    <!--Rows-->
    <div v-for="column in this.data.columns.filter(c => !c.disable)"
         :class="['m-k__c', getColumnClasses(column)]"
    >
      <div class="m-k__w">
        <span class="m-k__perc">
          {{ getPercent(column, producer, this.data.percents) }}%
        </span>

        <form class="m-k__markup-form" data-mark-form autocomplete="off"
              :data-marketplace="column.marketplaceKey"
              :data-seller="column.sellerId"
              :data-type="producer.type"
              :data-producer-id="producer.id"
        >
          <div class="m-k__inputs">
            <input type="number"
                   name="value"
                   step="0.01"
                   autocomplete="off"
                   placeholder="закуп"
                   :id="['_value_', getId(column, producer)].join('')"
                   :value="getMarkup('incoming', column, producer)"
                   @keyup.enter.prevent="submit($event)"
                   @keyup.shift.enter.prevent="rowSubmit($event)"
                   @keyup.shift.delete.prevent="rowClear($event)"
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {markupsMixin} from "../../mixins/markupsMixin";
import {mapState} from "pinia";
import {useMarkupsStore} from "../../stores/markups";

export default {
  name: "TheProducerLine",
  computed: {
    ...mapState(useMarkupsStore, [
      'data'
    ]),
  },
  props: ['producer'],
  mixins: [markupsMixin],
  methods: {
    getPercent(column, producer, percents) {
      const key = this.getId(column, producer);
      return percents[key] ? percents[key] : 0;
    },
    getId(column, producer) {
      return ['p',column.marketplaceKey, column.sellerId, producer.id].join('-');
    },
    getMarkup(type, column, producer) {
      const key = this.getId(column, producer);

      const getMarkupProperty = (markup) => {
        if (type === 'wholesale') return markup.percentWholesale;
        if (type === 'incoming') return markup.percent;
      };

      for (const markup of producer.markups) {
        const markupKey = ['p', markup.marketplace, markup.seller, producer.id].join('-');

        if (key === markupKey) {
          return getMarkupProperty(markup);
        }
      }

      return null;
    },
  }
}
</script>